import {
    GET_COLLEGE
} from '../constants/ActionTypes';

const INIT_STATE = {
    collegeId: '',
    loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_COLLEGE:
            //console.log(action, 'actionnn');
            return {
                collegeId: action.body,
                loading :false
            }
        default:
            return state;
    }
}